module.exports = __webpack_public_path__ + "img/gzhj.83e69e1d.png";